export default __webpack_public_path__ + "static/sketches-bb091aff5147f12f5f653177d40ad32d.png";